import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Highcharts from 'highcharts'
import { BAR_CHART_COLORS } from '../../Helpers/ChartConstants.js'
import { findDisplayableBenchmarks } from '../../Helpers/ETFUtility.js'
import { ETF_FUND, FUTURE_SCHOLAR_529 } from '../../Helpers/FundTypes.js'

class PerformanceCalendarYearReturns extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedTab: 'calendar-year-returns-chart',
    }
  }

  componentDidMount() {
    const { calendarYearReturns, fundGroup } = this.props

    this.renderHighCharts(calendarYearReturns)

    if (fundGroup === ETF_FUND || fundGroup === FUTURE_SCHOLAR_529) {
      calendarYearReturns.calendarYearReturns = findDisplayableBenchmarks(
        calendarYearReturns.calendarYearReturns
      )
    }
  }

  componentDidUpdate() {
    const { calendarYearReturns } = this.props

    this.renderHighCharts(calendarYearReturns)
  }

  setSelectedTab = (event) => {
    event.preventDefault()
    const toggleViewClass = event.currentTarget.dataset.toggleViewClass

    this.setState({
      selectedTab: toggleViewClass,
    })
  }

  renderTable(calendarYearReturns) {
    return (
      <table
        id="calendarYearReturnsTable"
        className="Table Table--reversed Table--striped"
      >
        <thead className="Table-header">
          <tr className="Table-row">
            <th className="Table-header"></th>
            <th className="Table-header u-textRight">
              {calendarYearReturns.calendarYearReturnLabels[0]}
            </th>
            <th className="Table-header u-textRight">
              {calendarYearReturns.calendarYearReturnLabels[1]}
            </th>
            <th className="Table-header u-textRight">
              {calendarYearReturns.calendarYearReturnLabels[2]}
            </th>
            <th className="Table-header u-textRight">
              {calendarYearReturns.calendarYearReturnLabels[3]}
            </th>
            <th className="Table-header u-textRight">
              {calendarYearReturns.calendarYearReturnLabels[4]}
            </th>
          </tr>
        </thead>
        <tbody className="Table-body">
          {calendarYearReturns.calendarYearReturns.map(
            (returnDetail, index) => {
              return (
                <tr className="Table-row" key={`cyr${index}`}>
                  <td className="Table-cell">{returnDetail.label}</td>
                  <td className="Table-cell u-textRight">
                    {returnDetail.oneYear}
                  </td>
                  <td className="Table-cell u-textRight">
                    {returnDetail.twoYear}
                  </td>
                  <td className="Table-cell u-textRight">
                    {returnDetail.threeYear}
                  </td>
                  <td className="Table-cell u-textRight">
                    {returnDetail.fourYear}
                  </td>
                  <td className="Table-cell u-textRight">
                    {returnDetail.fiveYear}
                  </td>
                </tr>
              )
            }
          )}
        </tbody>
      </table>
    )
  }

  getHighChartsData = (calendarYearReturns) => {
    let graphData = []

    calendarYearReturns.forEach((returnDetail) => {
      const name = returnDetail.label

      let dataArray = []
      dataArray.push(Number(returnDetail.oneYear))
      dataArray.push(Number(returnDetail.twoYear))
      dataArray.push(Number(returnDetail.threeYear))
      dataArray.push(Number(returnDetail.fourYear))
      dataArray.push(Number(returnDetail.fiveYear))

      graphData.push({ name: name, data: dataArray })
    })

    return graphData
  }

  renderHighCharts = (calendarYearReturns) => {
    const chartData = this.getHighChartsData(
      calendarYearReturns.calendarYearReturns
    )

    Highcharts.chart('calendar-year-returns-chart', {
      chart: {
        spacing: [10, 0, 10, 0],
        style: {
          fontFamily: 'Franklin Gothic Condensed',
          fontSize: '14px',
        },
        type: 'column',
      },
      credits: false,
      colors: BAR_CHART_COLORS,
      legend: {
        itemMarginBottom: 5,
        itemStyle: {
          color: 'rgb(35, 31, 32)',
          fontSize: '16px',
          lineHeight: '1em',
        },
        margin: 10,
        symbolPadding: 4,
        symbolHeight: 12,
        symbolRadius: 12,
      },
      plotOptions: {
        column: {
          borderWidth: 0,
          pointPadding: 0,
          states: {
            hover: {
              brightness: 0,
            },
          },
        },
      },
      tooltip: {
        backgroundColor: 'rgba(255,255,255, 0.95)',
        borderColor: 'rgba(35, 31, 32, 0.3)',
        borderRadius: 5,
        footerFormat: '</table>',
        headerFormat:
          '<h4 class="u-marginBottom2gu">{point.key}</h4>' +
          '<table class="Table" style="width: 300px;">',
        padding: 10,
        pointFormat:
          '<tr class="Table-row" style="background-color: transparent;">' +
          '<td class="Table-cell u-paddingBottom0 u-paddingLeft0 u-paddingRight0 u-paddingTop2gu u-textTight" style="width: 10px;">' +
          '<hr class="Bullet" style="color: {series.color};">' +
          '</td>' +
          '<td class="Table-cell u-paddingBottom0 u-paddingLeft1gu u-paddingRight4gu u-paddingTop2gu u-textTight">' +
          '{series.name}' +
          '</td>' +
          '<td class="Table-cell u-paddingBottom0 u-paddingHoriz0 u-paddingTop2gu u-textRight u-textTight">' +
          '{point.y:.2f}%' +
          '</td>' +
          '</tr>',
        shadow: false,
        shared: true,
        useHTML: true,
      },
      series: chartData,
      title: { text: '' },
      xAxis: {
        categories: [
          calendarYearReturns.calendarYearReturnLabels[0],
          calendarYearReturns.calendarYearReturnLabels[1],
          calendarYearReturns.calendarYearReturnLabels[2],
          calendarYearReturns.calendarYearReturnLabels[3],
          calendarYearReturns.calendarYearReturnLabels[4],
        ],
        crosshair: { color: 'rgba(35, 31, 32, 0.05)' },
        labels: {
          style: {
            color: 'rgba(35, 31, 32, 0.60)',
            fontSize: '14px',
          },
        },
        lineWidth: 0,
        tickWidth: 0,
      },
      yAxis: {
        labels: {
          format: '{value}%',
          style: {
            color: 'rgba(35, 31, 32, 0.60)',
            fontSize: '14px',
          },
        },
        gridLineColor: 'rgba(35, 31, 32, 0.10)',
        lineWidth: 0,
        minorTicks: true,
        title: { text: '' },
      },
    })
  }

  render() {
    const { calendarYearReturns } = this.props

    return (
      <div className="u-paddingBottom8gu" id="calendar-year-returns">
        <div className="Grid Grid--alignMiddle u-flexJustifyBetween u-marginBottom4gu">
          <div className="u-sizeFit u-sm-paddingBottom3gu u-sm-sizeFull">
            <h3>Calendar Year Returns (%)</h3>
          </div>

          <div className="u-sizeFit u-sm-sizeFull">
            <div className="Button-group">
              <a
                href="#"
                className={`Button Button--secondary Button--small data-visualization-toggle chart-toggle ${
                  this.state.selectedTab === 'calendar-year-returns-chart'
                    ? 'is-selected u-textColorWhite'
                    : ''
                }`}
                onClick={this.setSelectedTab}
                data-toggle-view-class="calendar-year-returns-chart"
              >
                Chart
              </a>
              <a
                href="#"
                className={`Button Button--secondary Button--small data-visualization-toggle table-toggle ${
                  this.state.selectedTab === 'calendar-year-returns-table'
                    ? 'is-selected u-textColorWhite'
                    : ''
                }`}
                onClick={this.setSelectedTab}
                data-toggle-view-class="calendar-year-returns-table"
              >
                Table
              </a>
            </div>
          </div>
        </div>

        <div
          id="calendar-year-returns-chart"
          className={`calendar-year-returns calendar-year-returns-chart ${
            this.state.selectedTab === 'calendar-year-returns-chart'
              ? ''
              : 'u-hidden'
          }`}
        ></div>
        <div
          id="calendar-year-returns-table"
          className={`u-overflowX calendar-year-returns calendar-year-returns-table ${
            this.state.selectedTab === 'calendar-year-returns-table'
              ? ''
              : 'u-hidden'
          }`}
        >
          {this.renderTable(calendarYearReturns)}
        </div>
      </div>
    )
  }
}

PerformanceCalendarYearReturns.propTypes = {
  calendarYearReturns: PropTypes.object.isRequired,
  fundGroup: PropTypes.string.isRequired,
}

export default PerformanceCalendarYearReturns
